import { Paragraph } from '@/components/common/Typography';
import { assert } from '@common/errors';
import { DEFAULT_RISK_SCORE } from '@common/goals';
import { useCurrentUser } from '@common/react/user';
import { useState } from 'react';
import { labelByIraType } from './helpers';
import { useOpenIraFlowContext } from './OpenIraFlow';
import { OpenIraFlowRiskSelectionContent } from './OpenIraFlowRiskSelectionContent';
import OpenIraFlowStep from './OpenIraFlowStep';

const OpenIraFlowPortfolioStep = () => {
    const { setStep, iraType, info, updateInfo } = useOpenIraFlowContext();
    const { userInfo } = useCurrentUser();
    // TODO: Consider refining this based on user age
    const recommendedRiskScore =
        userInfo.recommendedRiskScoreByHorizon?.['LONG_TERM'];
    assert(info);
    const [riskScore, setRiskScore] = useState(
        info.riskScore ?? recommendedRiskScore ?? DEFAULT_RISK_SCORE // TODO: Reconsider this default
    );
    const [isSubmitting, setIsSubmitting] = useState(false);

    const investmentType = 'DIRECT_INDEXING'; // TODO: Support other types

    return (
        <OpenIraFlowStep
            headerTitle={`Now, choose a portfolio mix for your ${labelByIraType[iraType]} IRA.`}
            onBack={() => {
                setIsSubmitting(true);
                updateInfo({
                    ...info,
                    investmentType,
                    riskScore,
                })
                    .then(() => setStep('BENEFICIARY'))
                    .finally(() => setIsSubmitting(false));
            }}
            onNext={() => {
                setIsSubmitting(true);
                updateInfo({
                    ...info,
                    investmentType,
                    riskScore,
                    lastCompletedRetirementStep: 'PORTFOLIO',
                })
                    .then(() => setStep('PLAN'))
                    .finally(() => setIsSubmitting(false));
            }}
            isSubmitting={isSubmitting}
        >
            <Paragraph textColor="textMuted"></Paragraph>
            <OpenIraFlowRiskSelectionContent
                description="The recommended risk score is based on your investor profile and an assumed retirement age of 65. When you have a longer investment horizon (aka you’re 10+ years away from retiring), you have the ability to take higher risk to earn higher returns. For most investors, this results in portfolios that have a higher percentage of stocks."
                riskScore={riskScore}
                recommendedRiskScore={recommendedRiskScore}
                minRiskScore={1}
                onChangeRiskScore={setRiskScore}
                investmentType={investmentType}
            />
        </OpenIraFlowStep>
    );
};

export default OpenIraFlowPortfolioStep;
